<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4OszFs/tc-custom/9781480403819.jpg?1733115612271" alt="This image is the cover for the book Changeling, The Daughters of England"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Changeling, The Daughters of England
      </h1>
      <p class="bookDescription body article font2">
        <b>Three young women bound by ties deeper than blood are swept up in a web of intrigue and betrayal in this haunting gothic tale </b><br/>Rebecca Mandeville arrives at Manorleigh with her mother amid rumors that Rebecca’s politically ambitious stepfather may have murdered his first wife. Homesick for her native Cornwall, Rebecca feels she’ll never belong at Benedict Lansdon’s ancestral estate—a place haunted by the phantoms of past crimes. When tragedy strikes, Rebecca struggles to move on, and becomes inextricably linked to two young girls: her half-sister Belinda and an orphan named Lucie. Teeming with scandal and murder, <i>The Changeling </i>is at once an atmospheric ghost tale and a gripping story of familial betrayal as powerful as the woman at its haunting center.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philippa Carr
      </h2>
      
      <p class="authorDescription body article">Philippa Carr (1906&ndash;1993) was one of the twentieth century&rsquo;s premier authors of historical fiction. She was born Eleanor Alice Burford, in London, England. Over the course of her career, she used eight pseudonyms, including Jean Plaidy and Victoria Holt&mdash;pen names that signaled a riveting combination of superlative suspense and the royal history of the Tudors and Plantagenets. Philippa Carr was Burford&rsquo;s last pseudonym, created in 1972. <i>The Miracle at St. Bruno&rsquo;s</i>, the first novel in Carr&rsquo;s acclaimed Daughters of England series, was followed by nineteen additional books. Burford died at sea on January 18, 1993. At the time of her death, there were over one hundred million copies of her books in print, and her popularity continues today.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0624f60c